import { render, staticRenderFns } from "./eventManage.vue?vue&type=template&id=5929d356&scoped=true"
import script from "./eventManage.vue?vue&type=script&lang=js"
export * from "./eventManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5929d356",
  null
  
)

export default component.exports